//
// ContextPill
//
// The line a message answers or reacts to — a questionnaire question, a thanks
// lead-in — quoted as a thin outlined bubble above the message bubble itself.
//
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { MessageText } from './components';

function ContextPill({
  author,
  text,
  className,
}) {
  if (!text) return null;

  return (
    <div
      className={classNames(
        'inline-block max-w-full rounded-2xl border-[0.5px] border-black/40 bg-transparent px-4 py-1',
        className,
      )}
    >
      <MessageText
        message={text}
        author={author}
        context
      />
    </div>
  );
}

ContextPill.propTypes = {
  author: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
};

export default ContextPill;
